@if(!loading){
<div class="logo"  routerLink="/dashboard">
  @if (this.appLogo) {
    <img matTooltip="{{this.appName}}" matTooltipPosition="right" src="{{this.appLogo}}" sizes="(min-width: 1281px) 40px, 100vw"/>
  }
  @if (!this.appLogo) {
    <app-icons icon="sl-logo" matTooltip="{{this.appName}}" matTooltipPosition="right"></app-icons>
  }
</div>

  <header class="menubar" [class.org-menu]="currentOrgWorkSpace && currentOrgWorkSpace.active">
    <nav>
      <div class="nav-header">
        <button class="icon-btn" (click)="hide()">arrow_back</button>
      </div>
      <div class="workspaces">
        <div class="workspace-section">
          <div class="workspace-menu">

            <div class="workspace-menu-body">
              <div class="workspace-menuitem">
                <app-avatar [image]="userWorkSpace.image" routerLink="/dashboard" [name]="userWorkSpace.name" [class.active]="userWorkSpace.active" size="medium"></app-avatar>
              </div>
            </div>
          </div>
        </div>

        <div class="current-workspace">
          <app-avatar [image]="userWorkSpace.image" routerLink="/dashboard" [name]="userWorkSpace.name" [class.active]="userWorkSpace.active" size="medium" [tooltip]="'menu.personal-profile'|translate"></app-avatar>
        </div>
        @if (!currentOrgWorkSpace && !orgWorkSpacesLoaded && !adminBlock) {
          <div class="current-workspace">
            <div class="avatar-loader"><div class="loader"></div></div>
          </div>
        }
        @if (currentOrgWorkSpace && orgWorkSpaces.length && !adminBlock) {
          <div class="workspace-section">
            <div class="current-workspace" [class.premium]="currentOrgWorkSpace.premium">
              <app-avatar [image]="currentOrgWorkSpace.image" [routerLink]="['/ows',currentOrgWorkSpace.id, branchService.vanityMode ? 'members' : 'dashboard']" [name]="currentOrgWorkSpace.name" [class.active]="currentOrgWorkSpace.active" size="medium" [showTooltip]="false"></app-avatar>
            </div>
            <div class="workspace-menu">
              <div class="workspace-menu-header">
                <h4>{{'menu.org-dashboard-title'|translate}}</h4>
                <div class="note">{{'menu.org-dashboard-text'|translate}}</div>
              </div>
              <div class="workspace-menu-body">
                @for (item of orgWorkSpaces; track item) {
                  <div class="workspace-menuitem" [routerLink]="['/ows',item.id]" [class.premium]="item.premium">
                    <app-avatar [image]="item.image" [name]="item.name" [class.active]="item.active" size="medium" [showTooltip]="false"></app-avatar>
                    <div class="workspace-menu-body-text">
                      <span class="highlight text-primary">{{item.name}}</span>
                      <span class="text-greytext">{{item.vatNumber}}</span>
                    </div>
                    <div (click)="$event.stopPropagation();" class="memberfichelink">
                      <a class="icon-btn greytext" [routerLink]="['/organisations/edit',item.id]" matTooltipPosition="right" matTooltipShowDelay="1000" [matTooltip]="'btn.go-to-memberfiche'|translate :{ organisation:item.name}">account_box</a>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <div class="menubar-items">

        @if (userWorkSpace.active) {
          <ul>
            <li>
              <a routerLink="/courses" routerLinkActive="active" [matTooltip]="'menu.opleidingen'|translate" matTooltipPosition="right">
                <i class="icon-btn">auto_stories</i><span>{{'menu.opleidingen'|translate}}</span>
              </a>
            </li>
            @if (!branchService.vanityMode) {
              <li>
                <a routerLink="/catalog" routerLinkActive="active" [matTooltip]="'catalog.title'|translate" matTooltipPosition="right">
                  <i class="icon-btn">travel_explore</i><span>{{'catalog.title'|translate}}</span>
                </a>
              </li>
            }
            <li>
              <a routerLink="/files" routerLinkActive="active" [matTooltip]="'menu.files'|translate" matTooltipPosition="right">
                <i class="icon-btn">folder_special</i><span>{{'menu.files'|translate}}</span>
              </a>
            </li>
            <li>
              <a routerLink="/organisations" routerLinkActive="active" [matTooltip]="'settings.organisations.menu-title'|translate" matTooltipPosition="right">
                <i class="icon-btn">business</i><span>{{'settings.organisations.menu-title'|translate}}</span>
              </a>
            </li>
            <li>
              <a routerLink="/knowledge" routerLinkActive="active" [matTooltip]="'menu.knowledgebase'|translate" matTooltipPosition="right">
                <i class="icon-btn">dvr</i><span>{{'menu.knowledgebase'|translate}}</span>
              </a>
            </li>
            @if (qhse) {
              <li>
                <a routerLink="/qhse" routerLinkActive="active" [matTooltip]="'menu.qhse'|translate" matTooltipPosition="right">
                  <i class="icon-btn">assignment</i><span>{{'menu.qhse'|translate}}</span>
                </a>
              </li>
            }
            @if (catalog) {
              <li>
                <a href="{{this.catalog}}" routerLinkActive="active" target="_blank" [matTooltip]="'menu.catalog'|translate: {branch:this.appName}" matTooltipPosition="right">
                  <i class="icon-btn">newspaper</i><span>{{'menu.catalog'|translate: {branch:this.appName} }}</span>
                </a>
              </li>
            }
          </ul>
        }
        @if(currentOrgWorkSpace && currentOrgWorkSpace.active){
          @if(gettingFeatures){
            <div class="loader"></div>
            }@else{
            <ul>
              <li *hasFeature="FeatureType.MEMBERS_ACCESS">
                <a [routerLink]="['/ows',currentOrgWorkSpace.id,'members']" routerLinkActive="active" [matTooltip]="'settings.organisationmembers.menu-header'|translate"  matTooltipPosition="right">
                  <i class="icon-btn">group</i><span>{{'settings.organisationmembers.menu-header'|translate}}</span>
                </a>
              </li>
              @if(!branchService.vanityMode){
                <li *hasFeature="FeatureType.LEARNINGPLAN_ACCESS">
                  <a [routerLink]="['/ows',currentOrgWorkSpace.id,'learning-plans']" routerLinkActive="active" [matTooltip]="'menu.learning-plans'|translate"  matTooltipPosition="right">
                    <i class="icon-btn" [class.premium]="!currentOrgWorkSpace.premium">event_note</i><span>{{'menu.learning-plans'|translate}}</span>
                  </a>
                </li>
                @if(currentOrgWorkSpace.premium){
                  <li *hasFeature="FeatureType.CERTIFICATES_ACCESS">
                    <a [routerLink]="['/ows',currentOrgWorkSpace.id,'certificates']" routerLinkActive="active" [matTooltip]="'menu.certificates'|translate" matTooltipPosition="right">
                      <i class="icon-btn">workspace_premium</i><span>{{'menu.certificates'|translate}}</span>
                    </a>
                  </li>
                  <!-- The whole map, read from the members and from the functions asking of them: a
                       readable type is what there is to read, so without one it is not offered. -->
                  @if (showQualifications) {
                    <ng-template #qualificationSubmenuContent>
                      <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-icons" [class.premium]="qualificationsUpsell">groups</i>
                        <span>{{'ows.qualification-matrix.title'|translate}}</span>
                      </a>
                      <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications','functions']" routerLinkActive="active">
                        <i class="material-icons" [class.premium]="qualificationsUpsell">badge</i>
                        <span>{{'ows.function-matrix.title'|translate}}</span>
                      </a>
                      <!-- The same people against one yardstick: a function, or a colleague. Levels,
                           so it takes the qualification module. -->
                      @if (showCompare) {
                        <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications','compare']" routerLinkActive="active">
                          <i class="material-icons" [class.premium]="!canCompare">compare_arrows</i>
                          <span>{{'ows.compare-matrix.title'|translate}}</span>
                        </a>
                      }
                      <!-- The catalogue both matrices read from, as a page of its own; it is there to
                           be managed, so it is only offered to whoever may. -->
                      @if (showCatalogue) {
                        <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications','catalogue']" routerLinkActive="active">
                          <i class="material-icons" [class.premium]="qualificationsUpsell">format_list_bulleted</i>
                          <span>{{'ows.qualifications.title'|translate}}</span>
                        </a>
                      }
                    </ng-template>
                    <li *hasFeature="FeatureType.MEMBERS_ACCESS" class="has-submenu"
                        (mouseenter)="openQualificationSubmenu()" (mouseleave)="closeQualificationSubmenu()"
                        cdkOverlayOrigin #qualificationSubmenuOrigin="cdkOverlayOrigin">
                      <!-- Not exact: the parent stays lit on the function matrix underneath it. -->
                      <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications']" routerLinkActive #qualificationLink="routerLinkActive" style="display:none"></a>
                      <a [class.active]="qualificationLink.isActive" matTooltipPosition="right">
                        <i class="icon-btn" [class.premium]="qualificationsUpsell">donut_large</i><span>{{'menu.qualifications'|translate}}</span>
                      </a>
                      <ng-template cdkConnectedOverlay
                        [cdkConnectedOverlayOrigin]="qualificationSubmenuOrigin"
                        [cdkConnectedOverlayOpen]="qualificationSubmenuOpen"
                        [cdkConnectedOverlayPositions]="submenuPositions"
                        [cdkConnectedOverlayPanelClass]="'submenu-overlay'">
                        <div class="submenu-panel"
                             (mouseenter)="openQualificationSubmenu()" (mouseleave)="closeQualificationSubmenu()">
                          <ng-container *ngTemplateOutlet="qualificationSubmenuContent"></ng-container>
                        </div>
                      </ng-template>
                    </li>
                    <li *hasFeature="FeatureType.MEMBERS_ACCESS" class="submenu-mobile-item">
                      <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications']" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" matTooltipPosition="right">
                        <i class="icon-btn" [class.premium]="qualificationsUpsell">groups</i><span>{{'ows.qualification-matrix.title'|translate}}</span>
                      </a>
                    </li>
                    <li *hasFeature="FeatureType.MEMBERS_ACCESS" class="submenu-mobile-item">
                      <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications','functions']" routerLinkActive="active" matTooltipPosition="right">
                        <i class="icon-btn" [class.premium]="qualificationsUpsell">badge</i><span>{{'ows.function-matrix.title'|translate}}</span>
                      </a>
                    </li>
                    @if (showCompare) {
                      <li *hasFeature="FeatureType.MEMBERS_ACCESS" class="submenu-mobile-item">
                        <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications','compare']" routerLinkActive="active" matTooltipPosition="right">
                          <i class="icon-btn" [class.premium]="!canCompare">compare_arrows</i><span>{{'ows.compare-matrix.title'|translate}}</span>
                        </a>
                      </li>
                    }
                    @if (showCatalogue) {
                      <li *hasFeature="FeatureType.MEMBERS_ACCESS" class="submenu-mobile-item">
                        <a [routerLink]="['/ows',currentOrgWorkSpace.id,'qualifications','catalogue']" routerLinkActive="active" matTooltipPosition="right">
                          <i class="icon-btn" [class.premium]="qualificationsUpsell">format_list_bulleted</i><span>{{'ows.qualifications.title'|translate}}</span>
                        </a>
                      </li>
                    }
                  }
                  <li *hasFeature="FeatureType.ANALYTICS_ACCESS">
                    <a [routerLink]="['/ows',currentOrgWorkSpace.id,'analytics']" routerLinkActive="active" [matTooltip]="'menu.analytics'|translate"  matTooltipPosition="right">
                      <i class="icon-btn">analytics</i><span>{{'menu.analytics'|translate}}</span>
                    </a>
                  </li>
                  <li *hasFeature="FeatureType.FORMS_SECTION_ACCESS">
                  <a [routerLink]="['/ows',currentOrgWorkSpace.id,'forms']" routerLinkActive="active" [matTooltip]="'menu.forms'|translate"  matTooltipPosition="right">
                    <i class="icon-btn" [class.premium]="!fs.hasFeature(FeatureType.FORMS_ACCESS)">speaker_notes</i><span>{{'menu.forms'|translate}}</span>
                  </a>
                  </li>
                }
              }@else {
                <li *hasFeature="FeatureType.ENROLMENTS_ACCESS">
                  <a [routerLink]="['/ows',currentOrgWorkSpace.id,'enrolments']" routerLinkActive="active" [matTooltip]="'menu.inschrijvingen'|translate" matTooltipPosition="right">
                    <i class="icon-btn">receipt</i><span>{{'menu.inschrijvingen'|translate}}</span>
                  </a>
                </li>
                <li *hasFeature="FeatureType.CONNECTIONS_ACCESS">
                  <a [routerLink]="['/ows',currentOrgWorkSpace.id,'connections']" routerLinkActive="active" [matTooltip]="'menu.connections'|translate" matTooltipPosition="right">
                    <i class="icon-btn">link</i>
                    <span>{{'menu.connections'|translate}}</span>
                  </a>
                </li>
              } 

              @if(hasMoreMenuItems){
              <li class="has-submenu"
                  (mouseenter)="openMoreSubmenu()" (mouseleave)="closeMoreSubmenu()"
                  cdkOverlayOrigin #moreSubmenuOrigin="cdkOverlayOrigin">
                <a [routerLink]="['/ows',currentOrgWorkSpace.id,'enrolments']" routerLinkActive #enrolLink="routerLinkActive" style="display:none"></a>
                <a [routerLink]="['/ows',currentOrgWorkSpace.id,'connections']" routerLinkActive #connLink="routerLinkActive" style="display:none"></a>
                <a [routerLink]="['/ows',currentOrgWorkSpace.id,'attachments']" routerLinkActive #attachLink="routerLinkActive" style="display:none"></a>
                <a [class.active]="enrolLink.isActive || connLink.isActive || attachLink.isActive">
                  <i class="icon-btn">more_horiz</i><span>{{'menu.more'|translate}}</span>
                </a>
                <ng-template cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="moreSubmenuOrigin"
                  [cdkConnectedOverlayOpen]="moreSubmenuOpen"
                  [cdkConnectedOverlayPositions]="submenuPositions"
                  [cdkConnectedOverlayPanelClass]="'submenu-overlay'">
                  <div class="submenu-panel"
                       (mouseenter)="openMoreSubmenu()" (mouseleave)="closeMoreSubmenu()">
                    <a *hasFeature="FeatureType.ENROLMENTS_ACCESS" [routerLink]="['/ows',currentOrgWorkSpace.id,'enrolments']" routerLinkActive="active">
                      <i class="material-icons">receipt</i>
                      <span>{{'menu.inschrijvingen'|translate}}</span>
                    </a>
                    <a *hasFeature="FeatureType.CONNECTIONS_ACCESS" [routerLink]="['/ows',currentOrgWorkSpace.id,'connections']" routerLinkActive="active">
                      <i class="material-icons">link</i>
                      <span>{{'menu.connections'|translate}}</span>
                    </a>
                    @if(attachmentModuleEnabled){
                      <a *hasFeature="FeatureType.ATTACHMENTS_ACCESS" [routerLink]="['/ows',currentOrgWorkSpace.id,'attachments']" routerLinkActive="active">
                        <i class="material-icons">attach_file</i>
                        <span>{{'ows.settings.attachments.menu-title'|translate}}</span>
                      </a>
                    }
                  </div>
                </ng-template>
              </li>
              <li *hasFeature="FeatureType.ENROLMENTS_ACCESS" class="submenu-mobile-item">
                <a [routerLink]="['/ows',currentOrgWorkSpace.id,'enrolments']" routerLinkActive="active" matTooltipPosition="right">
                  <i class="icon-btn">receipt</i><span>{{'menu.inschrijvingen'|translate}}</span>
                </a>
              </li>
              <li *hasFeature="FeatureType.CONNECTIONS_ACCESS" class="submenu-mobile-item">
                <a [routerLink]="['/ows',currentOrgWorkSpace.id,'connections']" routerLinkActive="active" matTooltipPosition="right">
                  <i class="icon-btn">link</i><span>{{'menu.connections'|translate}}</span>
                </a>
              </li>
              @if(currentOrgWorkSpace.premium && attachmentModuleEnabled){
                <li *hasFeature="FeatureType.ATTACHMENTS_ACCESS" class="submenu-mobile-item">
                  <a [routerLink]="['/ows',currentOrgWorkSpace.id,'attachments']" routerLinkActive="active" matTooltipPosition="right">
                    <i class="icon-btn">attach_file</i><span>{{'ows.settings.attachments.menu-title'|translate}}</span>
                  </a>
                </li>
              }
              }

            </ul>
          }
        }
        <div class="menubar-settings">
          @if (userWorkSpace.active) {
            @if (!this.adminBlock && !branchService.vanityMode) {
              <a routerLink="/cv" routerLinkActive="active" [matTooltip]="'menu.cv'|translate"  matTooltipPosition="right">
                <i class="icon-btn">contact_page</i><span>{{'menu.cv'|translate}}</span>
              </a>
            }
            @if (!this.adminBlock) {
              <a routerLink="/settings" routerLinkActive="active" [matTooltip]="'menu.instellingen'|translate"  matTooltipPosition="right">
                <i class="icon-btn">settings</i><span>{{'menu.instellingen'|translate}}</span>
              </a>
            }
          }
          <ng-container *hasFeature="FeatureType.SETTINGS_ACCESS">
            @if (!this.adminBlock && currentOrgWorkSpace && currentOrgWorkSpace.active) {
              <a [routerLink]="['/ows',currentOrgWorkSpace.id,'settings']" routerLinkActive="active" [matTooltip]="'menu.instellingen'|translate"  matTooltipPosition="right">
                <i class="icon-btn">settings</i><span>{{'menu.instellingen'|translate}}</span>
              </a>
            }
          </ng-container>
          <a (click)="onboardingWelcome.open()"  [matTooltip]="'menu.support'|translate"  matTooltipPosition="right"><i class="icon-btn outlined">help</i><span>{{'menu.support'|translate}}</span></a>
          <a (click)="logout();" routerLinkActive="active" [matTooltip]="'label.logout'|translate"  matTooltipPosition="right">
            <i class="icon-btn">logout</i><span>{{'label.logout'|translate}}</span>
          </a>
        </div>
      </div>
    </nav>
  </header>
}
<div class="toolbar">
  <div class="toolbar-toggle">
    <button class="icon-btn" (click)="show()">menu</button>
  </div>
</div>



<!-- Doubles as the help/feedback dialog: the same overlay invited members get on their first visit. -->
<app-onboarding-welcome #onboardingWelcome [currentOrganisationId]="currentOrgWorkSpace ? currentOrgWorkSpace.id : ''"></app-onboarding-welcome>